import { I18nClient } from './i18nClient';

/**
 * @deprecated Please use the i18nClient instead
 */
export const ReactLocalizationAPI = I18nClient;
